import React from 'react'
import styled from '@emotion/styled'

const ErrorBlockElement = styled.div`
  background: ${p => p.theme.colors.coral.c100};
  padding: ${p => p.theme.layout.spacing.s600}px;
  margin: ${p => p.theme.layout.spacing.s600}px;
  border-radius: 4px;
`

const ErrorBlockHeadingElement = styled.h2`
  color: ${p => p.theme.colors.negativeColor};
  font-size: ${p => p.theme.fonts.size.md};
  margin: 0 0 ${p => p.theme.fonts.size.sm};
`

const ErrorBlockDescriptionElement = styled.div`
  color: ${p => p.theme.colors.negativeColor};
  font-size: ${p => p.theme.fonts.size.sm};
  margin: 0;
`

// TODO: Disabled for enforcing lint, fix if possible
// eslint-disable-next-line no-undef
const ErrorBlock = (props: ErrorBlockPropsType) => {
  const {heading} = props

  return (
    <ErrorBlockElement>
      <ErrorBlockHeadingElement>{heading}</ErrorBlockHeadingElement>
      <ErrorBlockDescriptionElement>
        {props.children}
      </ErrorBlockDescriptionElement>
    </ErrorBlockElement>
  )
}

export default ErrorBlock
